/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateMessageRequest
 */
export interface CreateMessageRequest {
    /**
     * Sender facility for JWT callers. Must be provided together with receiver_facility_id.
     * @type {string}
     * @memberof CreateMessageRequest
     */
    sender_facility_id?: string;
    /**
     * Receiver facility for JWT callers. Must be provided together with sender_facility_id.
     * @type {string}
     * @memberof CreateMessageRequest
     */
    receiver_facility_id?: string;
    /**
     * Display name of the sending user, captured from the frontend at send time.
     * @type {string}
     * @memberof CreateMessageRequest
     */
    sender_user_name?: string;
    /**
     * Job title/role of the sending user, captured from the frontend at send time.
     * @type {string}
     * @memberof CreateMessageRequest
     */
    sender_user_title?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMessageRequest
     */
    content: string;
}

/**
 * Check if a given object implements the CreateMessageRequest interface.
 */
export function instanceOfCreateMessageRequest(value: object): value is CreateMessageRequest {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function CreateMessageRequestFromJSON(json: any): CreateMessageRequest {
    return CreateMessageRequestFromJSONTyped(json, false);
}

export function CreateMessageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMessageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sender_facility_id': json['sender_facility_id'] == null ? undefined : json['sender_facility_id'],
        'receiver_facility_id': json['receiver_facility_id'] == null ? undefined : json['receiver_facility_id'],
        'sender_user_name': json['sender_user_name'] == null ? undefined : json['sender_user_name'],
        'sender_user_title': json['sender_user_title'] == null ? undefined : json['sender_user_title'],
        'content': json['content'],
    };
}

export function CreateMessageRequestToJSON(json: any): CreateMessageRequest {
    return CreateMessageRequestToJSONTyped(json, false);
}

export function CreateMessageRequestToJSONTyped(value?: CreateMessageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sender_facility_id': value['sender_facility_id'],
        'receiver_facility_id': value['receiver_facility_id'],
        'sender_user_name': value['sender_user_name'],
        'sender_user_title': value['sender_user_title'],
        'content': value['content'],
    };
}

